import { userService } from "@/service";
import { useStore } from "@/store";
import { Toast } from "vant";
import { toRaw } from "@vue/runtime-core";

export function useHandleOpt() {
  const store = useStore();

  const logout = async (id) => {
    try {
      await userService.exitUser(toRaw(id));
      store.commit("setUserInfo", null);
    } catch (error) {
      Toast.fail("退出失败！");
    }
  };
  return {
    logout,
  };
}
